/**
 * Signup Page
 * Redirects to login - magic link handles both login and signup
 */

import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '~/contexts/AuthContext';
import { Button } from '~/components/ui/button';
import { Card } from '~/components/ui/card';

export default function Signup() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  // Redirect if already authenticated
  if (!isLoading && isAuthenticated) {
    return <Navigate to="/projects" replace />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md p-8 space-y-6">
        <div className="space-y-2 text-center">
          <h1 className="text-2xl font-bold">Welcome to Snaptics</h1>
          <p className="text-gray-600">
            Sign in with your email to get started. We'll send you a login link.
          </p>
          <p className="text-sm text-gray-500">
            If you don't have an account yet, one will be created automatically.
          </p>
        </div>
        <Button onClick={() => navigate('/login')} className="w-full">
          Go to Sign In
        </Button>
      </Card>
    </div>
  );
}
